<script>
  import Slider from "./Slider.svelte";

  export let items: Array<any>;
  export let itemsPerPage: number;
</script>

<div class="mobile-slider">
  <Slider {items} {itemsPerPage} gap={30} let:item>
    <slot {item} />
  </Slider>
</div>

<style lang="scss">
  .mobile-slider {
    display: grid;
    width: 100%;

    :global(.dot) {
      border: 2px solid $key-color;

      &.active {
        background-color: $key-color;
      }
    }
  }
</style>
